import React, { useEffect, useState } from 'react';
import maleImage from '../../../../assets/img/trafic/man.png';
import femaleImage from '../../../../assets/img/trafic/woman-avatar.png';
import langImage from '../../../../assets/img/trafic/language.png';

const CardWidget = ({ male, female, idle }) => {
  const cards = [
    { img: maleImage, numbers: male, label: 'Total Male' },
    { img: femaleImage, numbers: female, label: 'Total Female' },
    { img: langImage, numbers: idle, label: 'Idle Users' }
  ];

  const gradientColors = [
    'from-green-400 to-blue-500',
    'from-indigo-400 to-purple-500',
    'from-yellow-400 to-orange-500',
  ];

  return (
    <div className="mx-auto pt-5">
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {cards.map((card, index) => (
          <Card
            key={index}
            img={card.img}
            endNumber={card.numbers}
            label={card.label}
            gradientColor={gradientColors[index % gradientColors.length]}
          />
        ))}
      </div>
    </div>
  );
};

const Card = ({ img, endNumber, label, gradientColor }) => {
  const [number, setNumber] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const incrementTime = 10;
    const step = endNumber / (duration / incrementTime);

    const timer = setInterval(() => {
      start += step;
      if (start >= endNumber) {
        start = endNumber;
        clearInterval(timer);
      }
      setNumber(Math.ceil(start));
    }, incrementTime);

    return () => clearInterval(timer);
  }, [endNumber]);

  return (
    <div className={`flex justify-between items-center bg-gradient-to-tr ${gradientColor} p-6 rounded-2xl shadow-lg text-white`}>
      <div>
        <p className="text-2xl font-bold tracking-wide mb-4">{number}</p>
        <p className='capitalize text-md tracking-wide'>{label}</p>
      </div>
      <div>
        <img src={img} alt="img" className="w-14 h-14 rounded-lg" />
      </div>
    </div>
  );
};

export default CardWidget;
